import React from "react";
import { Mybook } from "../../assets/svgs/icons";

export interface CardSuggestionProps {
  title: string;
  titleColor?: string;
  description: string;
  onClick?: () => void;
  className?: string;
}

const CardSuggestion: React.FC<CardSuggestionProps> = ({
  title,
  titleColor = "#6d2ef2",
  description,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        box-border
        border border-[#eeeeee] rounded-[20px] p-3
        flex flex-col gap-1 items-center w-full
        bg-white hover:shadow-[0_4px_8px_rgba(0,0,0,0.08)]
        transition-all duration-200
        md:gap-2 md:p-3
        ${className}
      `}
    >
      {/* Title with icon */}
      <div className="flex items-center gap-1">
        <Mybook className={`w-5 h-5 md:w-6 md:h-6`} fill={titleColor} />
        <span
          className={`font-bold text-[14px] leading-[20px] tracking-[-0.28px] md:text-[16px] md:leading-[24px] md:tracking-[-0.32px]`}
          style={titleColor ? { color: titleColor } : undefined}
        >
          {title}
        </span>
      </div>

      {/* Description */}
      <div className="w-full">
        <p className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-[#666666] text-center">
          {description}
        </p>
      </div>
    </button>
  );
};

export default CardSuggestion;
